import { Injectable } from '@angular/core';

import { firstValueFrom, tap } from 'rxjs';

import { StylesLazyLoadingService } from '../deferred/styles/style-loading.service';
import { LiveEventListService, LiveOverviewModel } from './live-event-list.service';

@Injectable({ providedIn: 'root' })
export class LiveHighlightResolver {
    constructor(
        private liveEventListService: LiveEventListService,
        private stylesService: StylesLazyLoadingService,
    ) {}

    async resolve(): Promise<LiveOverviewModel | undefined> {
        const eventListService$ = this.liveEventListService.getHighlights().pipe(tap((model) => this.liveEventListService.notifyParent(model)));

        const [result] = await Promise.all([firstValueFrom(eventListService$, { defaultValue: undefined }), this.stylesService.lazyLoad('live')]);

        return result;
    }

    preResolve() {
        this.liveEventListService.getHighlights().subscribe();
        this.stylesService.lazyLoad('live');
    }
}
